import {
  Box,
  Button,
  TextField,
  Autocomplete,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";

const IEBFilter = forwardRef(
  ({ dropdownOptions, handleFilteredRows, rows }, ref) => {
    const [noIEBChecked, setNoIEBChecked] = useState(false);
    const [filterTerm, setFilterTerm] = useState("");
    const [selectedLocal, setSelectedLocal] = useState(null);
    const [filteredDropdownOptions, setFilteredDropdownOptions] =
      useState(dropdownOptions);

    useEffect(() => {
      setFilteredDropdownOptions(dropdownOptions);
    }, [dropdownOptions]);

    useEffect(() => {
      // ensure dropdown options only shows locals with no IEB when noIEB is checked
      if (noIEBChecked) {
        const filtered = rows
          .filter((row) => !row.IEBTimestamp) // keep only rows without a timestamp
          .map((row) => row.name); // extract only the names

        setFilteredDropdownOptions(filtered);
      } else {
        setFilteredDropdownOptions(dropdownOptions);
      }
    }, [noIEBChecked, rows, dropdownOptions]);

    useEffect(() => {
      const normalizedTerm = filterTerm.toLowerCase();

      const filteredRows = rows.filter((row) => {
        const matchesTerm = row.name.toLowerCase().includes(normalizedTerm);
        // if checked, local name must match term AND have no timestamp.
        // if not checked, just match the term.
        return noIEBChecked ? matchesTerm && !row.IEBTimestamp : matchesTerm;
      });

      handleFilteredRows(filteredRows);
      // handleFilteredRows is an inline function in the parent and
      // recreated every render — adding it would cause infinite loops.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [noIEBChecked, filterTerm, rows]);

    const handleNoIEBChecked = () => {
      setNoIEBChecked(!noIEBChecked);
    };

    const handleAffiliateSelection = (e, chosenAffiliate) => {
      setSelectedLocal(chosenAffiliate);
    };

    const handleClearFilters = () => {
      setNoIEBChecked(false);
      setFilterTerm("");
      setSelectedLocal(null);
      setFilteredDropdownOptions(dropdownOptions);
    };

    useImperativeHandle(ref, () => ({
      reset() {
        handleClearFilters();
      },
    }));

    return (
      <Box
        sx={{
          border: "solid 1px #e6e6e6",
          borderRadius: "4px",
          padding: "10px",
          backgroundColor: "white",
          height: "fit-content",
        }}
      >
        <Box className="autocomplete-component">
          <Autocomplete
            data-testid="select-locals-dropdown"
            disablePortal
            options={filteredDropdownOptions}
            getOptionLabel={(option) => option || ""}
            sx={{ width: 300 }}
            renderInput={(params) => (
              <TextField {...params} label="Select a local" />
            )}
            onChange={handleAffiliateSelection}
            onInputChange={(event, newInputValue) => {
              setFilterTerm(newInputValue);
            }}
            value={selectedLocal}
          />
        </Box>
        <Box>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={noIEBChecked}
                  onChange={handleNoIEBChecked}
                />
              }
              label="Show only locals with no IEB"
            />
          </FormGroup>
        </Box>
        <Box>
          <Button onClick={handleClearFilters}>Clear filters</Button>
        </Box>
      </Box>
    );
  }
);
IEBFilter.displayName = "IEBFilter";

export default IEBFilter;
